import { Injectable } from '@angular/core';
import { BaseAPIClass } from '@app/core/class/baseAPI.class';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TemaService extends BaseAPIClass {
  constructor(protected httpClient: HttpClient) {
    super(httpClient);
    this.baseUrl = '/temas';
  }

  getTemassByModulo(modolu_id: any): Observable<any[]> {
    return this.httpClient.get<any[]>(this.baseUrl + `/modulo/${modolu_id}`);
  }

  // getTemassByUser(modolu_id: any): Observable<any[]> {
  //   return this.httpClient.get<any[]>(this.baseUrl + `/modulo/${modolu_id}`);
  // }
  getTemassByUser(data: { user_id: any; modulo_id: string }): Observable<any[]> {
    return this.httpClient.post<any[]>(this.baseUrl + `/user`, data);
  }

  getAllTemas(term: any, modulo_id: string): Observable<any[]> {
    return this.httpClient.get<any[]>(this.baseUrl + `?term=${term}&modulo_id=${modulo_id}`);
  }

  getHabilitar(id: any) {
    return this.httpClient.get(this.baseUrl + `/habilitar/${id}`);
  }
}
